module.exports = __webpack_public_path__ + "img/search.85fe57f2.svg";